import FullScriptEditorDialog from './FullScriptEditorDialog';

export default FullScriptEditorDialog;
